module.exports = [{"type":"title","text":"2024-08-08"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續幣本位:新增WS DataType-ACCOUNT_UPDATE 賬戶更新"},{"type":"html","text":"永續幣本位:新增WS DataType-ORDER_TRADE_UPDATE 訂單更新推送"},{"type":"html","text":"永續幣本位:新增 WS DataType-ACCOUNT-CONFIG_UPDATE 槓桿倍數和保證金模式等配置更新推送"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-08-08.json
// module id = F1dE
// module chunks = 3